import {
    FETCH_PORTAL_TRAININGS,
    FETCH_TRAINING_DETAIL,
    SAVE_CONTENT_INFO,
    FETCH_TRAINING_DRAFT,
    COMPLETE_PORTAL_TRAINING,
    CLEARSTATE,
    GET_SCORM_FILE_CONTENT,
    FATCH_SCORM_TRAINING_INFO,
    SAVE_SCORM_TRAINING_INFO,
    DOWNLOAD_TRAINING_CERTIFICATE
} from './types';

const BACKEND_API = 'BACKEND_API';

export const fetchPortalTrainings = () => ({
    type: BACKEND_API,
    payload: {
        method: 'GET',
        url: '/portal_training/get_portal_trainings/',
        ...FETCH_PORTAL_TRAININGS
    }
});

export const fetchTrainingDetail = id => ({
    type: BACKEND_API,
    payload: {
        method: 'GET',
        url: `/portal_training/${id}/`,
        ...FETCH_TRAINING_DETAIL
    }
});

export const saveContentInfo = (id, data) => ({
    type: BACKEND_API,
    payload: {
        method: 'POST',
        url: `/portal_training/${id}/portal_training_draft/`,
        data,
        ...SAVE_CONTENT_INFO
    }
});

export const fetchTrainingDraft = id => ({
    type: BACKEND_API,
    payload: {
        method: 'GET',
        url: `/portal_training/${id}/portal_training_draft/`,
        ...FETCH_TRAINING_DRAFT
    }
});

export const completePortalTraining = id => ({
    type: BACKEND_API,
    payload: {
        method: 'POST',
        url: `/portal_training/${id}/complete_portal_training/`,
        ...COMPLETE_PORTAL_TRAINING
    }
});

export const downloadTrainingCertificate = id => ({
    type: BACKEND_API,
    payload: {
        method: 'GET',
        url: `/portal_training/${id}/complete_portal_training/`,
        ...DOWNLOAD_TRAINING_CERTIFICATE
    }
});

export const clearState = () => ({
    type: CLEARSTATE
});

export const getScormContent = id => ({
    type: BACKEND_API,
    payload: {
      method: 'get',
      url: `/portal_training/${id}/get_portal_scorm_file_content/`,
      ...GET_SCORM_FILE_CONTENT
    }
});

export const fetchScormTrainingInfo = (id, data) => ({
    type: BACKEND_API,
    payload: {
      method: 'GET',
      url: `/portal_training/${id}/scorm_portal_training_draft/`,
      data,
      ...FATCH_SCORM_TRAINING_INFO
    }
});

export const saveScormContentInfo = (id, data) => ({
    type: BACKEND_API,
    payload: {
      method: 'POST',
      url: `/portal_training/${id}/scorm_portal_training_draft/`,
      data,
      ...SAVE_SCORM_TRAINING_INFO
    }
});
